/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Parent_ChangedInputs */

const en_toast_parent_changed = /** @type {(inputs: Toast_Parent_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parent changed`)
};

const de_toast_parent_changed = /** @type {(inputs: Toast_Parent_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übergeordneter Vorgang geändert`)
};

/**
* | output |
* | --- |
* | "Parent changed" |
*
* @param {Toast_Parent_ChangedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const toast_parent_changed = /** @type {((inputs?: Toast_Parent_ChangedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Parent_ChangedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_toast_parent_changed(inputs)
	return en_toast_parent_changed(inputs)
});